module.exports = __webpack_public_path__ + "img/tab1-1@2x.8e807090.png";